(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/ticker/assets/javascripts/ticker.js') >= 0) return;  svs.modules.push('/widgets/ticker/assets/javascripts/ticker.js');

'use strict';

const {
  normalizeBingoWinners,
  normalizeCasinoWinners
} = svs.widget.ticker.utils;
const {
  TickerType,
  TickerFeed
} = svs.widget.ticker.constants;
const {
  loop,
  Marquee
} = window.DynamicMarquee;
const {
  createMarqueeSeparator,
  createMarqueePromoItem,
  createMarqueeWinnerItem
} = svs.widget.ticker.utilsMarquee;
const TICKER_SCROLL_RATE_RUNNING = -50;
const TICKER_SCROLL_RATE_PAUSED = 0;
class Ticker {
  constructor(options) {
    this.options = options;
    this.el = options.$el[0];
    this.endpoint = this.options.model.feed;
    this.tickerType = this.options.model.type;
    this.winnerList = this.options.model.winners;
    this.isPaused = false;
    const preferReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.marquee = new Marquee(this.el, {
      rate: preferReducedMotion ? TICKER_SCROLL_RATE_PAUSED : TICKER_SCROLL_RATE_RUNNING,
      startOnScreen: true
    });
    if (this.tickerType === TickerType.WINNERS) {
      this.template = svs.widget.ticker.templates.winners;
      this.control = loop(this.marquee, this.getWinnersMarqueeItems(this.winnerList));
    } else {
      this.template = svs.widget.ticker.templates.promo;
      this.control = loop(this.marquee, this.getPromoMarqueeItems(options.model.promoTexts), () => createMarqueeSeparator(this.options.model.brand));
    }
    if (!preferReducedMotion) {
      this.setupListeners(this.el);
    }
    this.subscribeToWinners();
  }
  getPromoMarqueeItems(items) {
    return items.map(item => () => createMarqueePromoItem(item));
  }
  getWinnersMarqueeItems(items) {
    return items.map((item, i) => () => createMarqueeWinnerItem(item, this.options.model.brand, i));
  }
  startTicker() {
    this.marquee.setRate(TICKER_SCROLL_RATE_RUNNING);
    this.isPaused = false;
  }
  pauseTicker() {
    this.marquee.setRate(TICKER_SCROLL_RATE_PAUSED);
    this.isPaused = true;
  }
  setupListeners(tickerEl) {
    if (svs.core.detect.formfactor.mobile()) {
      tickerEl.addEventListener('touchstart', () => {
        if (this.isPaused) {
          this.startTicker();
        } else {
          this.pauseTicker();
        }
      });
    } else {
      this.el.addEventListener('mouseenter', () => {
        this.pauseTicker();
      });
      this.el.addEventListener('mouseleave', () => {
        this.startTicker();
      });
      this.el.addEventListener('focusin', () => {
        this.pauseTicker();
      });
      this.el.addEventListener('focusout', () => {
        this.startTicker();
      });
    }
  }
  onSocketUpdate(data) {
    var _data$winnerFeed;
    if (!(data !== null && data !== void 0 && (_data$winnerFeed = data.winnerFeed) !== null && _data$winnerFeed !== void 0 && _data$winnerFeed.items)) {
      return;
    }
    let winners;
    if (this.options.model.feed === TickerFeed.BINGO) {
      var _svs$widgets;
      winners = normalizeBingoWinners(data.winnerFeed.items, (_svs$widgets = svs.widgets) === null || _svs$widgets === void 0 || (_svs$widgets = _svs$widgets.ticker) === null || _svs$widgets === void 0 || (_svs$widgets = _svs$widgets.data) === null || _svs$widgets === void 0 ? void 0 : _svs$widgets.bingoGames);
    } else {
      winners = normalizeCasinoWinners(data.winnerFeed.items);
    }
    const newWinners = winners.filter(value => this.winnerList.find(item => item.id !== value.id));
    const updWinners = [...this.winnerList.slice(newWinners.length), ...newWinners];
    this.winnerList = updWinners;
    this.control.update(this.getWinnersMarqueeItems(updWinners));
  }
  subscribeToWinners() {
    if (this.tickerType === TickerType.WINNERS) {
      svs.core.socket.subscribe("/casino/1/winnerfeed/".concat(this.endpoint), this.onSocketUpdate, this);
    }
  }
}
setGlobal('svs.widget.ticker.init', options => {
  var _options$$el$;
  if (!(options !== null && options !== void 0 && (_options$$el$ = options.$el[0]) !== null && _options$$el$ !== void 0 && (_options$$el$ = _options$$el$.dataset) !== null && _options$$el$ !== void 0 && _options$$el$.initialized)) {
    new Ticker(options);
    options.$el[0].dataset.initialized = 'true';
  }
});

 })(window);